import BuildsData from 'models/BuildsData';
import Whitelabel from 'models/Whitelabel';

const initBuilds = (whitelabel: Whitelabel): Whitelabel => ({
  ...whitelabel,
  builds: { data: {} as BuildsData, loading: { android: true, ios: true } },
});

export default initBuilds;
